import { getFestivalEdition } from "api/festival_edition/festival_edition";

export const queryFestivalEdition = ({ slug, user }) => ({
	queryKey: ["festival_edition", slug, user?.uid],
	queryFn: async () => getFestivalEdition({ authToken: user?.accessToken, slug }),
});
